import { debugLogger } from '@/utils/debug';

/**
 * Constants related to pricing plans
 */

// Legacy product/price IDs removed – using tier identifiers directly
export const PAYMENT_URLS = {
  premium_tier: '/pricing?checkout=premium_tier',
  whatsapp_tier: '/pricing?checkout=whatsapp_tier',
  profile_subscription: '/profile?tab=subscription',
} as const;

/**
 * Maps a plan ID to its corresponding tier name
 * @param planId The plan identifier
 * @returns The corresponding tier name
 */
// Direct tier identifiers used; helper no longer needed.

/**
 * Determines if the given plan is user's current plan
 * @param planId The plan identifier to check
 * @param currentTier The user's current subscription tier
 * @returns Boolean indicating if this is the user's current plan
 */
export const isCurrentPlanActive = (planId: string, currentTier: string): boolean => {
  debugLogger.log(`Comparing plan: ${planId} with current tier: ${currentTier}`);
  return currentTier === planId;
};

/**
 * Checks if a plan is available for purchase based on current tier
 * @param currentTier User's current subscription tier
 * @param targetPlanId Plan ID to check availability for
 * @returns Boolean indicating if the plan can be purchased
 */
export const isPlanAvailable = (currentTier: string, targetPlanId: string): boolean => {
  const targetTier = targetPlanId;
  
  // Free tier users can purchase any plan
  if (currentTier === 'free_tier') {
    return true;
  }
  
  // WhatsApp tier users can only upgrade to premium
  if (currentTier === 'whatsapp_tier') {
    return targetTier === 'premium_tier';
  }
  
  // Premium tier users already have the highest tier
  if (currentTier === 'premium_tier') {
    return false;
  }
  
  return true;
};
